import isPromise from 'p-is-promise'
import { AsyncAction, Payload, Store } from './types'
import { isEventLike, normalizeArray } from './utils'

export class AbortError extends Error {
  constructor(message?: string) {
    super(message)
    this.name = 'AbortError'
  }
}

export const asyncFlow =
  (...actions: AsyncAction[]) =>
  (store: Store, ...params: unknown[]): Payload => {
    const event = normalizeArray(params.filter(isEventLike))

    for (const e of Array.isArray(event) ? event : event ? [event] : []) {
      e.stopPropagation()
    }

    let payload: Payload = normalizeArray(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      params.reduce((acc: any[], param) => {
        if (isEventLike(param)) {
          if (!param.__IGNORE_TARGET_VALUE) {
            acc.push(param.target.value)
          }
        } else {
          acc.push(param)
        }

        return acc
      }, [])
    )

    try {
      const run = (action: AsyncAction, payload: Payload) =>
        ((result: unknown) =>
          isPromise(result)
            ? result.then((result) => result ?? payload)
            : result ?? payload)(
          action({
            ...store.getState(),
            event,
            payload,
          })
        )

      for (const action of actions) {
        payload = isPromise(payload)
          ? payload.then((payload) => run(action, payload))
          : run(action, payload)
      }

      if (isPromise(payload)) {
        return payload.then().catch((error) => {
          if (!(error instanceof AbortError)) {
            throw error
          }
        })
      }
    } catch (error) {
      if (error instanceof AbortError) {
        return payload
      }
    }

    return payload
  }
